var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Button/Edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Button/Edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1.000000, 1.000100)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#B7844D",
    points: "8.03835 0 0.96185 7.076 2.92235 9.0365 9.99885 1.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#B7844D",
    points: "0 10.0008 2.45 9.5088 0.4895 7.5483"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5726,
    y1: 9.61835,
    x2: 9.9991,
    y2: 9.61835,
    id: "Stroke-3",
    stroke: "#B7844D",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/Write.89914f72fc76d3b8fc89c38b13445962.svg";
export { ForwardRef as ReactComponent };